import { DocumentData, QueryDocumentSnapshot, SnapshotOptions } from '@angular/fire/firestore';
import { Alert as _Alert } from '../../../../../core/model/alert.model'

/**
 * LCC Event Model
 */
export class Alert extends _Alert {

  static toFirestore(): DocumentData {
    throw new Error('Read only');
  }

  static fromFirestore(snapshot: QueryDocumentSnapshot, options?: SnapshotOptions): Alert {
    return new Alert({
      ...snapshot.data(options),
      id: snapshot.id,
      title: '',
    });
  }
}
